import { render, staticRenderFns } from "./ReportMistake.vue?vue&type=template&id=1710e950"
import script from "./ReportMistake.vue?vue&type=script&lang=ts"
export * from "./ReportMistake.vue?vue&type=script&lang=ts"
import style0 from "./ReportMistake.vue?vue&type=style&index=0&id=1710e950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports